const API_URL = process.env.REACT_APP_API_URL;

async function request(path, options = {}) {
  let response;
  const isFormData = typeof FormData !== "undefined" && options.body instanceof FormData;
  try {
    response = await fetch(`${API_URL}${path}`, {
      credentials: "include",
      ...options,
      headers: {
        ...(options.body && !isFormData ? { "Content-Type": "application/json" } : {}),
        ...options.headers,
      },
    });
  } catch (error) {
    if (error.name === "AbortError") throw error;
    throw new Error("Der Blog ist momentan nicht erreichbar.");
  }
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || data.message || "Die Anfrage ist fehlgeschlagen.");
  }
  return data;
}

export function listPublicPosts({ limit = 12, offset = 0, signal } = {}) {
  const params = new URLSearchParams({ limit: String(limit), offset: String(offset) });
  return request(`/blog/posts?${params}`, { signal });
}

export function getPublicPost(slug, { signal } = {}) {
  return request(`/blog/posts/${encodeURIComponent(slug)}`, { signal });
}

export function listCreatorPosts({ status, signal } = {}) {
  const suffix = status ? `?status=${encodeURIComponent(status)}` : "";
  return request(`/creator/blog/posts${suffix}`, { signal });
}

export function getCreatorPost(id, { signal } = {}) {
  return request(`/creator/blog/posts/${id}`, { signal });
}

export function createPost(fields) {
  return request("/creator/blog/posts", {
    method: "POST",
    body: JSON.stringify(fields),
  });
}

export function updatePost(id, fields) {
  return request(`/creator/blog/posts/${id}`, {
    method: "PATCH",
    body: JSON.stringify(fields),
  });
}

export function publishPost(id, publishedAt = null) {
  return request(`/creator/blog/posts/${id}/publish`, {
    method: "POST",
    body: JSON.stringify(publishedAt ? { published_at: publishedAt } : {}),
  });
}

export function unpublishPost(id) {
  return request(`/creator/blog/posts/${id}/unpublish`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function deletePost(id) {
  return request(`/creator/blog/posts/${id}`, { method: "DELETE" });
}

export async function uploadCover(id, file, coverImageAlt) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("cover_image_alt", coverImageAlt || "");
  return request(`/creator/blog/posts/${id}/cover`, {
    method: "POST",
    body: formData,
  });
}

export function deleteCover(id) {
  return request(`/creator/blog/posts/${id}/cover`, { method: "DELETE" });
}
